import { Field, FieldError } from '@talentmesh/ui/components/field';
import { Textarea } from '@talentmesh/ui/components/textarea';
import { cn } from '@talentmesh/ui/lib/utils';
import { useController } from 'react-hook-form';

export interface CriteriaTextAreaInputProps {
    name?: string;
    disabled?: boolean;
    labelId?: string;
}

const CriteriaTextAreaInput = ({ name = '', disabled, labelId }: CriteriaTextAreaInputProps) => {
    const { field, fieldState } = useController({ name });
    const { error } = fieldState;

    return (
        <Field data-invalid={error ? true : undefined}>
            <Textarea
                name={field.name}
                value={field.value ?? ''}
                onChange={field.onChange}
                onBlur={field.onBlur}
                ref={field.ref}
                rows={4}
                disabled={disabled}
                aria-labelledby={labelId}
                aria-invalid={error ? true : undefined}
                className={cn(
                    'resize-none',
                    'aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:border-destructive aria-[invalid=true]:focus-visible:ring-destructive dark:aria-[invalid=true]:focus-visible:border-destructive/50 dark:aria-[invalid=true]:focus-visible:ring-destructive/50',
                )}
            />
            <FieldError>{error?.message ?? null}</FieldError>
        </Field>
    );
};

export default CriteriaTextAreaInput;
